import { Box, Typography, Paper } from "@mui/material";

const NoPermission = () => (
  <Box
    component={Paper}
    sx={{
      borderRadius: 2,
      backgroundColor: "transparent",
      minHeight: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
    }}
  >
    <Typography variant="h4" gutterBottom>
      You don’t have permission
    </Typography>
    <Typography variant="body1" color="text.secondary">
      This page is reserved for authorized users. Please contact your administrator
      to request access.
    </Typography>
  </Box>
);

export default NoPermission;
